const IconNote = () => (
  <svg
    width={7}
    height={4}
    viewBox="0 0 6 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 0.471191V1.00049C0 1.20768 0.167812 1.37549 0.375 1.37549H5.625C5.83219 1.37549 6 1.20768 6 1.00049V0.471191C6 0.264004 5.83219 0.0961914 5.625 0.0961914H0.375C0.167812 0.0961914 0 0.264004 0 0.471191ZM0 2.99973V3.52903C0 3.73622 0.167812 3.90403 0.375 3.90403H3.875C4.08219 3.90403 4.25 3.73622 4.25 3.52903V2.99973C4.25 2.79254 4.08219 2.62473 3.875 2.62473H0.375C0.167812 2.62473 0 2.79254 0 2.99973Z"
      fill="currentColor"
    />
  </svg>
)

export default IconNote
